module.exports = __webpack_public_path__ + "landing.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing.jpg
// module id = 299
// module chunks = 0